"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parallaxlib_1 = require("./parallaxlib");
var parallax = function () {
    var parallaxListener = function () {
        var viewport = document.getElementById('overflow');
        var parallax = new parallaxlib_1.BpParallax(viewport);
        parallax.init();
    };
    document.addEventListener('DOMContentLoaded', parallaxListener);
};
exports.default = parallax;
